import { Card, CardBody, Col, FormGroup, Input, Label, Row } from "reactstrap";
import { H6 } from "../../../../AbstractElements";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { ChooseActivities, VariationCheckboxs } from "../../../../Constant";
import { VARIATION_CHECHBOX, VARIATION_CHECHBOX_LIST } from "../../../../Data/FormControl/MegaOptions";
import VariationCheckboxUpgrade from "./VariationCheckboxUpgrade";

const VariationCheckbox = () => {
  return (
    <Col sm="12"> 
    <Card> 
     <CommonCardHeader title={VariationCheckboxs} span={VARIATION_CHECHBOX} />
      <CardBody> 
        <Row className="g-3">
          <Col xl="4" md="5">
            <div className="card-wrapper border rounded-3 h-100 checkbox-checked">
              <H6 className="sub-title">{ChooseActivities}</H6>
              {VARIATION_CHECHBOX_LIST.map(({id,color,check,labelText},index)=>(
              <div className="payment-wrapper" key={index}>
                <div className="payment-first">
                  <FormGroup className={`checkbox checkbox-${color}`} check>
                    <Input id={`check-${id}`} type="checkbox" defaultChecked={check}/>
                    <Label className="mb-0" htmlFor={`check-${id}`} check>{labelText}</Label>
                  </FormGroup>
                </div>
              </div>
              ))}
            </div>
          </Col>
          <VariationCheckboxUpgrade/>
        </Row>
      </CardBody>
    </Card>
  </Col>
  )
};

export default VariationCheckbox;
